import { PaymentFlowStatus } from "../types/payment";
import type { PaymentState } from "../types/payment";

const JOB_ROOM_PREFIX = "job:";

const TWO_FA_PROMPT_PREFIXES = ["login_2fa_prompt:", "payment_2fa_prompt:"] as const;

const TWO_FA_PROMPT_MESSAGE = "Enter 2FA code";

const INITIAL_PAYMENT_STATE: PaymentState = {
  paying: false,
  payResult: null,
  payError: null,
  payResults: null,
  pendingInvoices: [],
  paymentStatus: PaymentFlowStatus.IDLE,
  processedCount: 0,
  paymentLogs: [],
  paymentLogsLoading: false,
  paymentLogsError: null,
  currentPaymentLogId: null,
  logEntries: [],
  twoFaPrompt: null,
  twoFaCode: "",
};

export { JOB_ROOM_PREFIX, INITIAL_PAYMENT_STATE, TWO_FA_PROMPT_MESSAGE, TWO_FA_PROMPT_PREFIXES };
